module.exports = {
    API_KEY : "d42a0d190464a2be90977c3996382811",
    TZ : "Asia/Kuwait",
    
    // API_ADMIN_URL : "http://localhost:3300/v1/admin/",
    // API_BASE_URL : "http://localhost:3300/",
    // ASSETS_BASE_URL : "http://localhost:3300/",

    // API_ADMIN_URL : "https://staging.orbitkuwait.com/v1/admin/",
    // API_BASE_URL : "https://staging.orbitkuwait.com/",
    // ASSETS_BASE_URL : "https://staging.orbitkuwait.com/",

    API_ADMIN_URL : "https://orbitkuwait.com/v1/admin/",
    API_BASE_URL : "https://orbitkuwait.com/",
    ASSETS_BASE_URL : "https://orbitkuwait.com/",
    
    // ANALYSER_URL : "https://orbitkuwait.com/",

}